import { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Loader2, RefreshCw } from 'lucide-react';
import { diagnosticsAPI } from '../../lib/api';

export function FxFreshnessPanel() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    diagnosticsAPI.fxFreshness()
      .then(({ data: d }) => { if (!cancelled) setData(d); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center gap-2">
          <RefreshCw className="h-4 w-4 text-muted-foreground" />
          <CardTitle className="text-base">FX Rate Freshness</CardTitle>
        </div>
        <p className="text-xs text-muted-foreground">
          Newest cached rate per currency pair. Stale rates affect all converted figures.
        </p>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="flex justify-center py-4"><Loader2 className="h-5 w-5 animate-spin" /></div>
        ) : !data?.pairs ? (
          <p className="text-sm text-muted-foreground">Failed to load FX freshness data.</p>
        ) : (
          <div className="border rounded overflow-x-auto">
            <table className="w-full text-xs">
              <thead>
                <tr className="border-b bg-muted/50">
                  <th className="text-left px-3 py-1.5 font-medium">Pair</th>
                  <th className="text-left px-3 py-1.5 font-medium">Newest Rate Date</th>
                  <th className="text-right px-3 py-1.5 font-medium">Rate</th>
                  <th className="text-center px-3 py-1.5 font-medium">Status</th>
                </tr>
              </thead>
              <tbody>
                {data.pairs.map((p) => (
                  <tr key={p.pair} className="border-b last:border-0">
                    <td className="px-3 py-1.5 font-mono">{p.pair}</td>
                    <td className="px-3 py-1.5">{p.newest_rate_date || 'none'}</td>
                    <td className="px-3 py-1.5 text-right font-mono">{p.rate != null ? p.rate : '-'}</td>
                    <td className="px-3 py-1.5 text-center">
                      <Badge variant={p.status === 'ok' ? 'default' : 'destructive'} className="text-[10px]">
                        {p.status}
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
